import { Grid } from "@mui/material"
import React from "react"
import AddFarm from "./AddFarm"
import ListFarms from "./ListFarms"
import { useQuery, gql } from "@apollo/client"
import { CircularProgress, Typography } from "@mui/material"

const LIST_WAVE_BUOYS = gql`
  query {
    wave_buoys {
      id
      name
    }
  }
`

export default function FarmManagement() {
  const { data, loading, error } = useQuery(LIST_WAVE_BUOYS)
  if (loading) return <CircularProgress />
  if (error) return <Typography>{error.message}</Typography>
  const waveBuoys = data?.wave_buoys || []
  return (
    <Grid container spacing={3} style={{ padding: 18 }}>
      <Grid item sm={6} xs={12}>
        <AddFarm waveBuoys={waveBuoys} />
      </Grid>
      <Grid item sm={6} xs={12}>
        <ListFarms waveBuoys={waveBuoys} />
      </Grid>
    </Grid>
  )
}
